<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      全局设置
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="110px">
      <el-form-item
        label="页面名称："
        prop="pageName">
        <el-input
          v-model="form.pageName"
          placeholder="请输入页面名称"></el-input>
      </el-form-item>
      <el-form-item
        label="H5标题："
        prop="pageTitle">
        <el-input
          v-model="form.pageTitle"
          placeholder="请输入H5标题"></el-input>
      </el-form-item>
      <el-form-item
        required=""
        label="场景类型："
        prop="sceneType">
        <el-radio-group v-model="form.sceneType">
          <el-radio-button :label="0">普通场景</el-radio-button>
          <el-radio-button :label="1">限时场景</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.sceneType === 1"
        label="日期范围："
        prop="time">
        <el-date-picker
          v-model="form.time"
          style="width: 100%;"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WeHeader',
  components: { },
  props: {
    value: {
      type: Object,
      default() {
        return {
          pageName: '',
          pageTitle: '',
          sceneType: 0,
          time: null
        }
      }
    }
  },
  data() {
    return {
      rules: {
        pageName: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        pageTitle: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择限时场景的日期范围', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(v => {
          if (v) {
            resolve()
          } else {
            reject(new Error(JSON.stringify({ pop: 'headers' })))
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.settings {
  // display: flex;
  // flex-direction: column;
}

.settings .el-card__header {
  padding: 10px 20px;
}

.settings .el-card__body {
  // flex: 1;
  padding: 10px;
  // display: flex;
  // flex-direction: column;
}

.settings .settings-header {
  font-size: 16px;
  font-weight: 600;
}
</style>
